import { GF_FieldError, GF_Textarea } from '../../../model/gforms/gform';
import useGravityForm, {
  ACTION_TYPES,
  FieldValue,
  StringFieldValue,
} from '../../../hooks/GFormsHooks';
import { useEffect } from 'react';
import { FieldDescription } from './subparts/FieldDescription';
import { FieldDecorator } from './subparts/FieldDecorator';

interface Props {
  field: GF_Textarea;
  fieldErrors: GF_FieldError[];
}

export default function TextAreaField({ field, fieldErrors }: Props) {
  const {
    id,
    formId,
    type,
    label,
    description,
    defaultValue,
    cssClass,
    isRequired,
    placeholder,
    visibility,
    maxLength,
  } = field;
  const htmlId = `field_${formId}_${id}`;
  const { state, dispatch } = useGravityForm();
  const fieldValue = state.find(
    (fieldValue: FieldValue) => fieldValue.id === id
  ) as StringFieldValue | undefined;
  const value = fieldValue !== undefined ? fieldValue.value : defaultValue;

  useEffect(() => {
    if (defaultValue !== '' && fieldValue === undefined) {
      dispatch({
        type: ACTION_TYPES.updateTextAreaFieldValue,
        fieldValue: {
          id,
          value: defaultValue || '',
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`relative border border-primary px-5 pt-3 rounded-2xl mt-4 md:mt-5 gfield gfield-${type} ${cssClass} ${
        visibility === 'hidden' ? 'hidden' : ''
      }`.trim()}
    >
      <label
        className="text-sm text-black font-medium pt-3.5 left-4 top-[1px] w-[calc(100%-32px)] md:w-[calc(100%-48px)] md:pt-5 md:left-6 "
        htmlFor={htmlId}
      >
        {label}
      </label>
      <FieldDecorator>
        <textarea
          rows={4}
          className="w-full border-0 text-black text-sm italic pl-0 focus:ring-0 focus:ring-opacity-0 focus:ring-transparent focus:border-primary"
          name={String(id)}
          id={htmlId}
          required={Boolean(isRequired)}
          placeholder={placeholder || ''}
          value={value}
          maxLength={maxLength}
          onChange={(event) => {
            dispatch({
              type: ACTION_TYPES.updateTextAreaFieldValue,
              fieldValue: {
                id,
                value: event.target.value,
              },
            });
          }}
        />
      </FieldDecorator>
      <FieldDescription description={description} />
      {fieldErrors?.length
        ? fieldErrors.map((fieldError) => (
            <p
              key={fieldError.id}
              className="error-message text-error font-medium text-sm mt-2"
            >
              {fieldError.message}
            </p>
          ))
        : null}
    </div>
  );
}
